import Vue from 'vue';
import { loadLanguage } from '../../core/i18nUtils';

export default (i18n) => {
  const vue = new Vue({
    el: '#recuritment',
    i18n,
    template: '<Recuritment />',
    components: {
      Project: () => import('./Recuritment'),
    },
    async beforeCreate() {
      await loadLanguage([
        'main',
        'stock_info',
      ]);

      switch (window.lang) {
        case 'english':
          this.$i18n.locale = 'en';
          break;
        default:
          this.$i18n.locale = 'zh';
      }
    },
  });

  return vue;
};
